/* eslint-disable max-classes-per-file */
import { Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { EventService, IEvent } from "~app/common/services/cqs/event.service";
import { ITplFilterTypes } from "../components/tpl-filter/tpl-filter.models";
import { ITplArbetsorder } from "../models/dtos";

export class TplEventHandler {
    private readonly ngUnsubscribe$ = new Subject<void>();

    constructor(
        private readonly eventService: EventService) {
    }

    onTransporttilldelningModified(callback: (e: TplTransporttilldelningModified) => void) {
        this.eventService
            .subscribeEvent<TplTransporttilldelningModified>(TplTransporttilldelningModified.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onDestineringModified(callback: (e: TplDestineringModified) => void) {
        this.eventService
            .subscribeEvent<TplDestineringModified>(TplDestineringModified.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    onFilterApplied(callback: (e: TplFilterApplied) => void) {
        this.eventService
            .subscribeEvent<TplFilterApplied>(TplFilterApplied.type)
            .pipe(takeUntil(this.ngUnsubscribe$))
            .subscribe(event => callback(event));
    }

    unsubscribe() {
        this.ngUnsubscribe$.next();
        this.ngUnsubscribe$.complete();
    }
}

export class TplTransporttilldelningModified implements IEvent {
    $type: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "tpl.transporttilldelning.modified";

    constructor(arbetsorderList?: ITplArbetsorder[]) {
        this.$type = TplTransporttilldelningModified.type;
    }
}

export class TplDestineringModified implements IEvent {
    $type: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "tpl.destinering.modified";

    constructor(arbetsorderList?: ITplArbetsorder[]) {
        this.$type = TplDestineringModified.type;
    }
}

export class TplFilterApplied implements IEvent {
    filterState: ITplFilterTypes;
    $type: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "tpl.filter.applied";

    constructor(filterState: ITplFilterTypes) {
        this.$type = TplFilterApplied.type;
        this.filterState = filterState;
    }
}

export class TplFilterReset implements IEvent {
    $type: string;
    // eslint-disable-next-line sonarjs/public-static-readonly
    static type = "tpl.filter.reset";

    constructor() {
        this.$type = TplFilterApplied.type;
    }
}
